import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import { BodySmall } from '@styled';
import colors from '@general/colors';

const ContainerLabelStyled = styled.label`
    display: ${props => (props.inline ? 'inline-flex' : 'flex')};
    cursor: pointer;
    margin-bottom: 0;
    position: relative;

    &.disabled {
        cursor: not-allowed;
        opacity: 1;
    }

    &:hover .checkbox {
        border-color: ${colors.darkGray};
    }

    &:focus-within .checkbox {
        border-color: ${colors.darkGray};
    }
`;

const InputStyled = styled.input`
    position: absolute;
    opacity: 0;

    &:checked ~ span {
        &::after {
            display: block;
        }
    }
`;

const CheckBoxStyled = styled.span`
    background-color: white;
    border: 2px solid ${colors.lightGray};
    height: 20px;
    left: 0;
    opacity: 1 !important;
    position: absolute;
    top: 0;
    transition: border-color 0.2s ease-in-out;
    width: 20px;

    &::after {
        border: solid black;
        border-width: 0 1px 1px 0;
        content: '';
        display: none;
        height: 8px;
        left: 6px;
        position: absolute;
        top: 3px;
        transform: rotate(45deg);
        width: 4px;
    }

    &.disabled {
        border: 2px solid ${colors.lightGray} !important;

        &::after {
            border: solid ${colors.mediumGray} !important;
            border-width: 0 1px 1px 0 !important;
        }
    }
`;

const CheckboxWithoutForm = ({ checked = false, children, disabled, onCheckChange, inline }) => {
    return (
        <ContainerLabelStyled className={classNames({ disabled })} inline={inline}>
            <InputStyled
                checked={checked}
                disabled={disabled}
                type="checkbox"
                onChange={e => onCheckChange(e.target.checked)}
            />

            <CheckBoxStyled className={classNames('checkbox', { disabled })} />

            {children && (
                <BodySmall
                    as="span"
                    className={classNames('ml-1.75rem', {
                        'text-medium-gray': disabled,
                    })}
                >
                    {children}
                </BodySmall>
            )}
        </ContainerLabelStyled>
    );
};

CheckboxWithoutForm.propTypes = {
    inline: PropTypes.bool,
    checked: PropTypes.bool,
    children: PropTypes.node,
    disabled: PropTypes.bool,
    onCheckChange: PropTypes.func.isRequired,
};

export default CheckboxWithoutForm;
